import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Modal,
  Heading,
  Overflow,
  ModalFooter,
} from 'next/components/ui';

export default function ErrorModal({ visible, pinName, onClose }) {
  return (
    <Modal visible={visible} size="s" onClose={onClose}>
      <Heading>Error publishing {pinName}</Heading>
      <Overflow>
        Please, check your internet connection. If the problem persists, contact
        support.
      </Overflow>
      <ModalFooter>
        <Button onClick={onClose}>Okay</Button>
      </ModalFooter>
    </Modal>
  );
}

ErrorModal.propTypes = {
  visible: PropTypes.bool,
  pinName: PropTypes.string,
  onClose: PropTypes.func,
};
